import dynamic from 'next/dynamic'

import { configuration } from './config'

const CasesSlider = dynamic(() =>
  import('@dynamic-components/sections/CasesSlider')
)

export function DevOpsSuccessSection() {
  return <CasesSlider {...configuration} />
}
